module.exports = __webpack_public_path__ + "static/media/helsinki-1.ed5ce4ea.jpg";